// `getEl` is read each time: the element may be replaced or removed.
import { isRouted, sharedAudioContext } from "./audio_graph.es6";

export function elementHolder(id, kind, getEl, extra = {}) {
  const idle = (el) => !el || !(el.currentSrc || el.getAttribute("src"));
  const hasData = (rs) => {
    const el = getEl();
    return idle(el) || (!el.seeking && el.readyState >= rs);
  };
  const contextRuns = () => {
    const el = getEl();
    if (idle(el) || !isRouted(el)) return true;
    const ctx = sharedAudioContext();
    return !ctx || ctx.state === "running";
  };
  return {
    ...extra,
    id,
    kind,
    ready: () => hasData(3) && contextRuns(),
    settled: () => hasData(4) && contextRuns(),
    blockedBy: () => (hasData(3) && !contextRuns() ? "context" : null),
    failed: () => {
      const el = getEl();
      return !idle(el) && !!el.error;
    },
    retry: () => {
      const el = getEl();
      if (el && typeof el.load === "function") el.load();
    },
  };
}

// Fetches a source again when its element is gone (the box left the stage): a muted, detached
// element that is never played or attached. Whether the next mount reuses it is up to the browser cache.
export function reloadSource(tag, url) {
  if (!url || typeof document === "undefined") return null;
  const el = document.createElement(tag);
  el.muted = true;
  el.preload = "auto";
  const release = () => {
    el.removeAttribute("src");
    el.load();
  };
  el.addEventListener("canplaythrough", release, { once: true });
  el.addEventListener("error", release, { once: true });
  el.src = url;
  el.load();
  return el;
}
